import { createFileRoute, useNavigate, useRouterState } from '@tanstack/react-router';
import { useEffect } from 'react';

import { useAuth } from '@/app/providers/AuthProvider';
import { ROUTES } from '@/constants/routes';
import { Loader } from '@/design-system/components/Loader';
import { AdminLayout } from '@/layouts/admin/AdminLayout';
import { sessionStorageService } from '@/services/session-storage-service';

/**
 * Authenticated admin shell. Session restore happens here; the matched page's
 * capability is enforced in AdminLayout so a hidden sidebar link cannot be
 * opened by URL. That is defense-in-depth — the API still has to refuse the data.
 */
function AuthenticatedShell() {
  const { status } = useAuth();
  const navigate = useNavigate();
  const href = useRouterState({ select: (state) => state.location.href });

  useEffect(() => {
    if (status !== 'unauthenticated') return;
    sessionStorageService.setReturnPath(href);
    void navigate({ to: ROUTES.signIn, replace: true });
  }, [href, navigate, status]);

  if (status !== 'authenticated') {
    return <Loader label="Checking your session" className="min-h-dvh" />;
  }

  return <AdminLayout />;
}

export const Route = createFileRoute('/admin/_app')({
  component: AuthenticatedShell,
});
